module.exports = __webpack_public_path__ + "img/a685_reset.c5998e88.png";